import { buildTranslate } from 'locales'
import {
  asRecoveryAiTermsItems,
  RECOVERY_AI_TERMS_SECTIONS,
} from './recoveryAiTermsSections'

const t = buildTranslate('legal.recovery_ai_terms')

const section = (num: number, title: string, body: string) =>
  `<h2>${num}. ${title}</h2><p>${body}</p>`

const listSection = (num: number, title: string, items: string[]) =>
  `<h2>${num}. ${title}</h2>` +
  items.map((item, i) => `<p>${num}.${i + 1} ${item}</p>`).join('')

// Built from the same locale keys AND section manifest RecoveryAiTerms.tsx
// renders, so the downloadable copy can't drift from the on-page terms —
// neither the prose nor the section order/numbering. HTML (not .txt or .md)
// is required here so the Billing Terms / Additional Terms links stay
// clickable in the downloaded file.
export const buildRecoveryAiTermsDocument = (): string => {
  const title = t('title')
  const sections = RECOVERY_AI_TERMS_SECTIONS.map(({ key, kind }, i) => {
    const num = i + 1
    const sectionTitle = t(`${key}.title`)
    return kind === 'prose'
      ? section(num, sectionTitle, t(`${key}.content`))
      : listSection(
          num,
          sectionTitle,
          asRecoveryAiTermsItems(t(`${key}.items`))
        )
  })

  const body = [
    `<p>${t('intro')}</p>`,
    `<p>${t('attestation')}</p>`,
    `<p>${t('incorporation')}</p>`,
    ...sections,
  ].join('\n')

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" />
<title>${title}</title>
<style>
  body { font-family: -apple-system, Helvetica, Arial, sans-serif; max-width: 720px; margin: 40px auto; padding: 0 20px; color: #23282d; line-height: 1.6; }
  h1 { font-size: 24px; }
  h2 { font-size: 18px; margin-top: 28px; }
  a { color: #0073bf; }
</style>
</head>
<body>
<h1>${title}</h1>
${body}
</body>
</html>
`
}
